export const displayNominalValue = (
  quantityRepresentation,
  priceRepresentation,
  nominalValue,
) =>
  quantityRepresentation === 'Q' && priceRepresentation === 'C'
    ? nominalValue
    : null;
